import Vue from 'vue';

export default class Questionnaire {
    constructor(vueInstance) {
        if (!(vueInstance instanceof Vue)) {
            console.error('Vue instance is required!');
        }

        this.vue = vueInstance;
    }

    get() {
        return this.vue.$route.query.q || null;
    }

    set(questionnaire) {
        this.vue.$router.replace({
            query: {
                ...this.vue.$route.query,
                q: questionnaire
            }
        }).catch(err => {});

        return questionnaire;
    }
}